import React, { Component } from "react";
import { Card, CardHeader, CardBody, UncontrolledAlert } from "reactstrap";
import DataTable from "../../Shared/DataTable";

import { MdDelete, MdSearch } from "react-icons/md";

export class MerchantLocationTable extends Component {
  render() {
    const columns = [
      {
        Header: "Title",
        accessor: "title"
      },
      {
        Header: "Description",
        accessor: "description"
      }
    ];

    const {
      match,
      fetching,
      data,
      error,
      filterData,
      selectRow,
      pages,
      page,
      pageSize,
      deleteRow,
      showModal,
      setPageNumber,
      setPageSize
    } = this.props;

    const actions = [
      {
        name: "view",
        btnText: "View",
        btnAction: selectRow,
        btnClass: "btn-success",
        btnIcon: MdSearch,
        tooltip: "View"
      },
      {
        name: "cancel",
        btnText: "Delete",
        btnAction: showModal,
        btnClass: "btn-danger",
        btnIcon: MdDelete,
        hiddenParam: "hasPassed",
        tooltip: "Cancel"
      }
    ];

    return (
      <div>
        <Card className="pp4">
          <CardHeader>Merchant Locations</CardHeader>
          <CardBody>
            {error && (
              <UncontrolledAlert color="danger">
                {error.message}
              </UncontrolledAlert>
            )}
            <DataTable
              columns={columns}
              loading={fetching}
              manual={true}
              pages={pages}
              page={page}
              pageSize={pageSize}
              urlParams={match}
              data={data ? data.data : []}
              count={data ? data.count : 0}
              defaultPageSize={10}
              deleteRow={deleteRow}
              selectRow={selectRow}
              showModal={showModal}
              filterData={filterData}
              setPageNumber={setPageNumber}
              setPageSize={setPageSize}
              searchParam="searchKey"
              hideSearchParam={true}
              actions={actions}
            />
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default MerchantLocationTable;
